// ========================================
// Category Dashboards — Panel Académico, diseño C2 (2026-10-25)
// La semana arriba (cada clase con su lista), las cifras en una franja y después el mes,
// la lista pasada mes a mes, las formaciones por tipo, lo que se imparte, las aulas de hoy
// y las herramientas. Bloques personalizables como el Inicio (DashboardView); estilos en
// assets/css/views/inicio.css (.inv-*) y academico.css (.aca-*).
// ========================================

Object.assign(window.CategoryDashboards, {
    _acaWeekOffset: 0,
    _acaDay: null,
    _acaAttendance: null,
    _acaFigs: {},

    renderAcademico() {
        const D = DashboardView;
        const now = new Date();
        const formations = typeof DataManager !== 'undefined' ? DataManager.getAll(DataManager.KEYS.FORMATIONS) : [];
        const subjectsCount = typeof DataManager !== 'undefined' ? DataManager.getAll(DataManager.KEYS.SUBJECTS).length : 0;
        const month = D._iso(now).slice(0, 7);
        const monthClasses = (typeof ClassService !== 'undefined' ? ClassService.getClasses() : []).filter(c => String(c.startDate || '').startsWith(month));
        const isEditMode = this.isEditMode('academico');
        const widgetsConfig = this.getWidgetsConfig('academico');
        this._acaNeedClasses();

        const ctx = { formations, subjectsCount, monthClasses };
        this._lastAcademicoCtx = ctx;
        const day = now.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' });

        return `
        <div class="dnr-proposal inicio-view aca-view">
            <section class="inv-head">
                <div class="inv-head-text">
                    <h1 class="inv-title">Académico</h1>
                    <p class="inv-sub">${Utils.sanitizeHTML(day.charAt(0).toUpperCase() + day.slice(1))} · ${formations.length} formaciones · ${subjectsCount} asignaturas · ${monthClasses.length} clases este mes</p>
                </div>
                <button type="button" id="btn-cog-academico" class="inv-btn" style="display: ${isEditMode ? 'none' : 'flex'};" ${UIEvents.attr('click', () => CategoryDashboards.toggleWidgetDrawer('academico'))}>
                    <i class="fas fa-sliders" aria-hidden="true"></i> Personalizar
                </button>
            </section>
            ${D._renderDrawer(widgetsConfig, isEditMode, 'academico', 'Personalizar el panel')}
            ${D._renderEditBanner(isEditMode, 'academico', 'el panel')}
            <div id="widgets-grid-academico" class="dnr-widget-grid inv-grid">
                ${widgetsConfig.map((w, i) => this.renderAcademicoWidget(w, isEditMode, ctx, i)).join('')}
            </div>
        </div>`;
    },

    renderAcademicoWidget(w, isEditMode, ctx, i) {
        const builders = {
            'aca-semana': () => this._acaSemana(),
            'aca-cifras': () => this._acaCifras(ctx),
            'aca-mes': () => this._acaMes(),
            'aca-lista-meses': () => this._acaListaMeses(),
            'aca-tipos': () => this._acaTipos(ctx),
            'aca-imparticion': () => this._acaImparticion(ctx),
            'aca-aulas': () => this._acaAulas(),
            'aca-herramientas': () => this._acaHerramientas()
        };
        if (!builders[w.id]) return '';
        return DashboardView._dnrWidgetShell(w, isEditMode, builders[w.id](), i, 'academico');
    },

    // La semana que se ve y el mes en curso; al llegar sus clases, se vuelve a pintar.
    _acaNeedClasses() {
        if (typeof FileStorage === 'undefined' || !FileStorage.needClasses) return;
        const now = new Date(), monday = this._acaMonday();
        const from = new Date(Math.min(monday, new Date(now.getFullYear(), now.getMonth(), 1)));
        const to = new Date(Math.max(new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 6), new Date(now.getFullYear(), now.getMonth() + 1, 0)));
        FileStorage.needClasses(from, to, () => { if (App.currentView === 'academico') this.reRenderDashboard('academico'); });
    },

    _acaMonday() {
        const m = DashboardView._monday();
        return new Date(m.getFullYear(), m.getMonth(), m.getDate() + this._acaWeekOffset * 7);
    },

    _acaNames(c) {
        const subject = typeof SubjectService !== 'undefined' ? SubjectService.getSubject(c.subjectId) : null;
        const formation = typeof FormationService !== 'undefined' ? FormationService.getFormation(c.formationId) : null;
        return { subject: subject ? subject.name : 'Clase', formation: formation ? (formation.commercialName || formation.name) : '', formationName: formation ? formation.name : '' };
    },

    // Estado de la lista de una clase: pasada, sin pasar (ya terminada), ahora o nada.
    _acaListState(c, iso) {
        const now = new Date(), today = DashboardView._iso(now);
        const hm = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
        const ended = iso < today || (iso === today && (c.endTime || c.startTime || '99') <= hm);
        if (iso === today && !ended && c.startTime && c.startTime <= hm) return { text: 'Ahora', cls: 'is-now' };
        if (!ended || !this._acaAttendance) return null;
        if (iso < this._acaAttendance.since) return null;
        return this._acaAttendance.recorded.has(`${c.id}|${iso}`) ? { text: 'Lista pasada', cls: 'is-ok' } : { text: 'Sin lista', cls: 'is-bad' };
    },

    _acaSemana() {
        const D = DashboardView, monday = this._acaMonday(), today = D._iso(new Date());
        const holidays = typeof DataManager !== 'undefined' ? (DataManager.getHolidays() || []) : [];
        const palette = ['is-c1', 'is-c2', 'is-c3', 'is-c4', 'is-c5'], colorOf = new Map();
        const labels = ['LUN', 'MAR', 'MIÉ', 'JUE', 'VIE', 'SÁB', 'DOM'];
        const days = labels.map((label, i) => {
            const d = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + i), iso = D._iso(d);
            return { label: `${label} ${d.getDate()}`, iso, classes: D._classesOn(iso), weekend: i >= 5 };
        }).filter(d => !d.weekend || d.classes.length);
        const all = days.flatMap(d => d.classes.map(c => this._acaListState(c, d.iso)));
        const missing = all.filter(s => s && s.cls === 'is-bad').length;
        const sunday = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 6);
        const range = `${monday.getDate()} ${monday.getMonth() !== sunday.getMonth() ? monday.toLocaleDateString('es-ES', { month: 'short' }) + ' ' : ''}al ${sunday.getDate()} de ${sunday.toLocaleDateString('es-ES', { month: 'long' })}`;
        const go = delta => () => { this._acaWeekOffset = delta === 0 ? 0 : this._acaWeekOffset + delta; this._acaNeedClasses(); this._acaRepaint('aca-semana'); };
        return `
            <div class="inv-card-head">
                <h2 class="inv-card-title">Semana del ${Utils.sanitizeHTML(range)} <span class="inv-muted">${all.length} ${all.length === 1 ? 'clase' : 'clases'}${missing ? ` · ${missing} sin lista` : ''}</span></h2>
                <div class="aca-week-nav" role="group" aria-label="Semana">
                    <button type="button" class="inv-btn" aria-label="Semana anterior" ${UIEvents.attr('click', go(-1))}>←</button>
                    <button type="button" class="inv-btn ${this._acaWeekOffset === 0 ? 'is-primary' : ''}" ${UIEvents.attr('click', go(0))}>Esta semana</button>
                    <button type="button" class="inv-btn" aria-label="Semana siguiente" ${UIEvents.attr('click', go(1))}>→</button>
                </div>
            </div>
            <div class="inv-week-cols" style="grid-template-columns: repeat(${days.length}, minmax(150px, 1fr));">
                ${days.map(d => `
                    <div class="inv-week-col ${d.iso === today ? 'is-today' : ''} ${holidays.includes(d.iso) ? 'is-holiday' : ''}">
                        <div class="inv-week-head">
                            <span>${d.label}${d.iso === today ? ' · HOY' : ''}</span>
                            ${holidays.includes(d.iso) ? '<span class="inv-pill is-bad">Festivo</span>' : `<span class="inv-muted">${d.classes.length || ''}</span>`}
                        </div>
                        <div class="inv-week-body">
                            ${d.classes.map(c => {
                                const n = this._acaNames(c), state = this._acaListState(c, d.iso);
                                const key = c.formationId || c.subjectId || '';
                                if (!colorOf.has(key)) colorOf.set(key, palette[colorOf.size % palette.length]);
                                return `
                                    <button type="button" class="inv-ev ${colorOf.get(key)}" title="Ir a la programación de esta clase"
                                        ${UIEvents.attr('click', () => CategoryDashboards.goToClassSchedule(c.formationId || '', c.subjectId || '', n.formationName, n.subject))}>
                                        <span class="inv-ev-time">${Utils.sanitizeHTML(c.startTime || '')}${c.endTime ? `–${Utils.sanitizeHTML(c.endTime)}` : ''}</span>
                                        <strong>${Utils.sanitizeHTML(n.subject)}</strong>
                                        ${n.formation || c.classroom ? `<span class="inv-ev-sub">${Utils.sanitizeHTML([n.formation, c.classroom].filter(Boolean).join(' · '))}</span>` : ''}
                                        ${state ? `<span class="aca-list ${state.cls}">${state.text}</span>` : ''}
                                    </button>`;
                            }).join('') || '<span class="inv-week-empty">Sin clases</span>'}
                        </div>
                    </div>`).join('')}
            </div>`;
    },

    _acaCifras(ctx) {
        const D = DashboardView, now = new Date(), today = D._iso(now);
        const hm = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
        const types = this._acaTypeCounts(ctx.formations);
        const next = ctx.monthClasses.filter(c => c.startDate > today || (c.startDate === today && (c.startTime || '') >= hm))
            .sort((a, b) => `${a.startDate} ${a.startTime}`.localeCompare(`${b.startDate} ${b.startTime}`))[0];
        const nextText = next ? `Próxima: ${next.startDate === today ? 'hoy' : new Date(`${next.startDate}T12:00:00`).toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric' })} ${next.startTime || ''}, ${this._acaNames(next).subject}` : 'No quedan clases este mes';
        const cells = [
            { section: 'formaciones', label: 'Formaciones', value: ctx.formations.length, sub: types.map(t => `${t.count} ${t.label.toLowerCase()}`).join(' · ') || 'Sin formaciones', go: 'formaciones' },
            { section: 'calendario', label: 'Clases del mes', value: ctx.monthClasses.length, sub: nextText, go: 'calendario' },
            { section: 'asistencia', id: 'aca-fig-lista', label: 'Lista pasada', value: '…', sub: 'Últimos 3 meses', go: 'asistencia' },
            { section: 'memorias-asignatura', id: 'aca-fig-memorias', label: 'Memorias', value: '…', sub: 'Cargando…', go: 'memorias-asignatura' },
            { section: 'calificaciones-admin', id: 'aca-fig-notas', label: 'Calificaciones', value: '…', sub: 'Actas finales', go: 'calificaciones' },
            { section: 'gestion-tareas', id: 'aca-fig-tareas', label: 'Tareas', value: '…', sub: 'Entregas de las tareas abiertas', go: 'gestion-tareas' }
        ].filter(c => D._can(c.section)).map(c => ({ ...c, ...(c.id && this._acaFigs[c.id]) }));
        return `
            <div class="inv-money">
                ${cells.map(c => `
                    <button type="button" class="inv-money-cell" ${c.id ? `id="${c.id}"` : ''} ${UIEvents.attr('click', () => App.navigate(c.go))}>
                        <span class="inv-label">${c.label}</span>
                        <span class="inv-money-value aca-fig-value ${c.warn ? 'is-warn' : ''}">${Utils.sanitizeHTML(String(c.value))}</span>
                        <span class="inv-money-sub aca-fig-sub">${Utils.sanitizeHTML(c.sub)}</span>
                    </button>`).join('')}
            </div>`;
    },

    _acaTypeCounts(formations) {
        return (typeof FormationTypeService !== 'undefined' ? FormationTypeService.getTypes() : [])
            .map(type => ({ label: type.pluralName || type.name, count: formations.filter(f => f.type === type.id).length }))
            .filter(t => t.count > 0);
    },

    _acaMes() {
        const D = DashboardView, now = new Date(), year = now.getFullYear(), month = now.getMonth();
        const today = now.getDate(), sel = this._acaDay || today;
        const holidays = typeof DataManager !== 'undefined' ? (DataManager.getHolidays() || []) : [];
        const lead = (new Date(year, month, 1).getDay() + 6) % 7, total = new Date(year, month + 1, 0).getDate();
        const iso = d => D._iso(new Date(year, month, d));
        const cells = [...Array(lead).fill(null), ...Array.from({ length: total }, (_, i) => i + 1)];
        const selClasses = D._classesOn(iso(sel));
        const title = now.toLocaleDateString('es-ES', { month: 'long', year: 'numeric' });
        return `
            ${D._head(Utils.sanitizeHTML(title.charAt(0).toUpperCase() + title.slice(1)), D._can('calendario') ? { label: 'Calendario global', go: () => App.navigate('calendario') } : null)}
            <div class="aca-cal" role="grid" aria-label="${Utils.sanitizeHTML(title)}">
                ${['L', 'M', 'X', 'J', 'V', 'S', 'D'].map(d => `<span class="aca-cal-dow" aria-hidden="true">${d}</span>`).join('')}
                ${cells.map(d => d === null ? '<span></span>' : `
                    <button type="button" class="aca-cal-day ${d === sel ? 'is-on' : ''} ${d === today ? 'is-today' : ''} ${holidays.includes(iso(d)) ? 'is-holiday' : ''} ${D._classesOn(iso(d)).length ? 'has-classes' : ''}"
                        aria-pressed="${d === sel}" aria-label="${d} de ${now.toLocaleDateString('es-ES', { month: 'long' })}" ${UIEvents.attr('click', () => { this._acaDay = d; this._acaRepaint('aca-mes'); })}>${d}</button>`).join('')}
            </div>
            <div class="aca-cal-day-list">
                <strong>${sel === today ? 'Hoy' : `${sel} de ${now.toLocaleDateString('es-ES', { month: 'long' })}`}</strong>
                ${selClasses.length ? selClasses.map(c => {
                    const n = this._acaNames(c);
                    return `<button type="button" class="inv-line" ${UIEvents.attr('click', () => CategoryDashboards.goToClassSchedule(c.formationId || '', c.subjectId || '', n.formationName, n.subject))}>
                        <span><span class="inv-mono">${Utils.sanitizeHTML(c.startTime || '')}</span> ${Utils.sanitizeHTML(n.subject)}</span>
                        <span class="inv-muted">${Utils.sanitizeHTML(c.classroom || '')}</span></button>`;
                }).join('') : '<p class="inv-empty">Sin clases ese día.</p>'}
            </div>`;
    },

    _acaListaMeses() {
        const D = DashboardView, data = this._acaAttendance;
        const months = [2, 1, 0].map(back => {
            const d = new Date(new Date().getFullYear(), new Date().getMonth() - back, 1);
            const ym = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
            const m = data && data.monthly.find(x => x.yearMonth === ym);
            return { name: d.toLocaleDateString('es-ES', { month: 'short' }).replace('.', '').toUpperCase(), pct: m && m.expected ? Math.round(m.coveragePct) : null };
        });
        return `
            ${D._head('Lista pasada por mes', { label: 'Pasar lista', go: () => App.navigate('asistencia') })}
            <div class="aca-bars">
                ${months.map(m => `
                    <div class="aca-bar">
                        <strong>${data ? (m.pct === null ? '—' : `${m.pct} %`) : '…'}</strong>
                        <span class="aca-bar-track" aria-hidden="true"><i style="height:${m.pct === null ? 0 : Math.max(3, m.pct)}%"></i></span>
                        <span class="inv-label">${m.name}</span>
                    </div>`).join('')}
            </div>
            <p class="inv-empty">${data ? (data.expected ? `${data.recordedCount} de ${data.expected} clases con lista en los últimos 3 meses.` : 'No había clases en los últimos 3 meses.') : 'Cargando…'}</p>`;
    },

    _acaTipos(ctx) {
        const D = DashboardView, types = this._acaTypeCounts(ctx.formations), max = Math.max(1, ...types.map(t => t.count));
        return `
            ${D._head('Formaciones por tipo', { label: 'Formaciones', go: () => App.navigate('formaciones') })}
            ${types.length ? `<div class="inv-funnel aca-types">
                ${types.map(t => `
                    <span class="inv-funnel-l">${Utils.sanitizeHTML(t.label)}</span>
                    <span class="inv-bar" aria-hidden="true"><i style="width:${Math.round(t.count / max * 100)}%"></i></span>
                    <strong class="inv-funnel-n">${t.count}</strong>`).join('')}
            </div>` : '<p class="inv-empty">Todavía no hay formaciones.</p>'}
            <p class="inv-empty">${ctx.subjectsCount} asignaturas en el plan de estudios</p>`;
    },

    _acaImparticion(ctx) {
        const D = DashboardView, hours = new Map();
        for (const c of ctx.monthClasses) {
            if (!c.subjectId) continue;
            const h = c.startTime && c.endTime && Utils.calculateDuration ? Utils.calculateDuration(c.startTime, c.endTime) : 0;
            hours.set(c.subjectId, (hours.get(c.subjectId) || 0) + h);
        }
        const rows = [...hours].map(([id, h]) => {
            const subject = SubjectService.getSubject(id), formation = subject && typeof FormationService !== 'undefined' ? FormationService.getFormation(subject.formationId) : null;
            return { name: subject ? subject.name : 'Asignatura', formation: formation ? (formation.commercialName || formation.name) : '', h: Math.round(h * 10) / 10 };
        }).sort((a, b) => b.h - a.h);
        const max = Math.max(1, ...rows.map(r => r.h));
        return `
            ${D._head(`En impartición este mes <span class="inv-muted">${rows.length} ${rows.length === 1 ? 'asignatura' : 'asignaturas'}</span>`, { label: 'Plan de estudios', go: () => App.navigate('plan-estudios') })}
            ${rows.length ? `<div class="aca-hours">
                ${rows.slice(0, 7).map(r => `
                    <span class="aca-hours-name" title="${Utils.sanitizeHTML(r.name)}"><strong>${Utils.sanitizeHTML(r.name)}</strong>${r.formation ? ` <span class="inv-muted">${Utils.sanitizeHTML(r.formation)}</span>` : ''}</span>
                    <span class="inv-bar" aria-hidden="true"><i style="width:${Math.round(r.h / max * 100)}%"></i></span>
                    <strong class="inv-funnel-n">${String(r.h).replace('.', ',')} h</strong>`).join('')}
            </div>` : '<p class="inv-empty">Este mes no hay clases programadas.</p>'}`;
    },

    // Cada aula de las clases de hoy, con su día en una barra (de 9:00 a 21:00, o más si hace falta).
    _acaAulas() {
        const D = DashboardView, now = new Date(), today = D._iso(now);
        const hm = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
        const mins = t => { const [h, m] = String(t || '0:0').split(':').map(Number); return h * 60 + (m || 0); };
        const classes = D._classesOn(today).filter(c => String(c.classroom || '').trim());
        const startH = Math.min(9, ...classes.map(c => Math.floor(mins(c.startTime) / 60)));
        const endH = Math.max(21, ...classes.map(c => Math.ceil(mins(c.endTime || c.startTime) / 60)));
        const pos = t => Math.max(0, Math.min(100, (mins(t) - startH * 60) / ((endH - startH) * 60) * 100));
        const rooms = [...new Set(classes.map(c => c.classroom.trim()))].sort((a, b) => a.localeCompare(b, 'es')).map(name => {
            const list = classes.filter(c => c.classroom.trim() === name);
            const cur = list.find(c => c.startTime <= hm && hm < (c.endTime || c.startTime)), next = list.find(c => c.startTime > hm);
            const label = c => { const n = this._acaNames(c), prof = D._professorName(D._classProfessorId(c)); return [n.subject, prof].filter(Boolean).join(' · '); };
            return { name, list, cur, next,
                state: cur ? ['En uso', 'is-ok'] : next ? ['Libre', 'is-warn'] : ['Libre', ''],
                detail: cur ? label(cur) : next ? `Siguiente: ${label(next)}` : 'Sin más clases hoy',
                when: cur ? `hasta ${cur.endTime || ''}` : next ? `a las ${next.startTime}` : '' };
        });
        const inUse = rooms.filter(r => r.cur).length;
        const ticks = [startH, Math.round((startH * 3 + endH) / 4), Math.round((startH + endH) / 2), Math.round((startH + endH * 3) / 4), endH];
        const nowPos = pos(hm), showNow = mins(hm) >= startH * 60 && mins(hm) <= endH * 60;
        return `
            <div class="inv-card-head">
                <h2 class="inv-card-title">Aulas hoy ${rooms.length ? `<span class="inv-pill ${inUse ? 'is-ok' : ''}">${inUse} en uso · ${hm}</span>` : ''}</h2>
                ${D._can('mapa-interactivo') ? `<button type="button" class="inv-link" ${UIEvents.attr('click', () => App.navigate('mapa-interactivo'))}>Mapa <span aria-hidden="true">→</span></button>` : ''}
            </div>
            ${rooms.length ? `
                <div class="aca-room-scale" aria-hidden="true"><span></span><span class="aca-room-ticks">${ticks.map(t => `<span>${t}</span>`).join('')}</span></div>
                ${rooms.map(r => `
                    <div class="aca-room">
                        <div class="aca-room-top">
                            <strong>${Utils.sanitizeHTML(r.name)}</strong>
                            <span class="aca-room-track">
                                ${r.list.map(c => `<span class="aca-room-block ${c === r.cur ? 'is-now' : (c.endTime || c.startTime) <= hm ? 'is-past' : ''}" style="left:${pos(c.startTime)}%; width:${Math.max(1, pos(c.endTime || c.startTime) - pos(c.startTime))}%" title="${Utils.sanitizeHTML(`${c.startTime}–${c.endTime || ''} ${this._acaNames(c).subject}`)}"></span>`).join('')}
                                ${showNow ? `<span class="aca-room-now" style="left:${nowPos}%" aria-hidden="true"></span>` : ''}
                            </span>
                        </div>
                        <div class="aca-room-bottom">
                            <span class="inv-pill ${r.state[1]}">${r.state[0]}</span>
                            <span class="aca-room-detail">${Utils.sanitizeHTML(r.detail)}</span>
                            <span class="inv-mono">${Utils.sanitizeHTML(r.when)}</span>
                        </div>
                    </div>`).join('')}` : '<p class="inv-empty">Hoy no hay clases con aula asignada.</p>'}`;
    },

    _acaHerramientas() {
        const tools = [['Pasar lista', 'asistencia', 'asistencia'], ['Programación', 'calendario-formacion', 'calendario-formacion'], ['Calendario global', 'calendario', 'calendario'],
            ['Calificaciones', 'calificaciones', 'calificaciones-admin'], ['Memorias', 'memorias-asignatura', 'memorias-asignatura'], ['Tareas', 'gestion-tareas', 'gestion-tareas'],
            ['Mapa de aulas', 'mapa-interactivo', 'mapa-interactivo'], ['Plan de estudios', 'plan-estudios', 'plan-estudios'], ['Formaciones', 'formaciones', 'formaciones']]
            .filter(t => DashboardView._can(t[2]));
        return `
            <nav class="aca-tools" aria-label="Herramientas académicas">
                ${tools.map(([label, route]) => `<a href="/${route}" class="inv-quick-link" ${UIEvents.attr('click', event => { event.preventDefault(); App.navigate(route); })}>${label}</a>`).join('')}
            </nav>`;
    },

    // Vuelve a pintar un solo bloque (al cambiar de semana o de día, o al llegar datos).
    _acaRepaint(id) {
        const card = document.getElementById('widget-' + id);
        const config = this.getWidgetsConfig('academico'), w = config.find(x => x.id === id);
        if (!card || !w || !this._lastAcademicoCtx) return;
        const i = config.indexOf(w);
        SafeHTML.replace(card, this.renderAcademicoWidget(w, this.isEditMode('academico'), this._lastAcademicoCtx, i));
    },

    goToClassSchedule(formationId, subjectId, formationName, subjectName) {
        let targetFormation = null;
        if (formationId && typeof DataManager !== 'undefined') {
            targetFormation = DataManager.getById(DataManager.KEYS.FORMATIONS, formationId);
        }
        if (!targetFormation && formationName && typeof DataManager !== 'undefined') {
            const allFormations = DataManager.getAll(DataManager.KEYS.FORMATIONS);
            targetFormation = allFormations.find(f => f.name.toLowerCase().includes(formationName.toLowerCase()) || formationName.toLowerCase().includes(f.name.toLowerCase()));
        }
        if (!targetFormation && typeof DataManager !== 'undefined') {
            const allFormations = DataManager.getAll(DataManager.KEYS.FORMATIONS);
            if (allFormations.length > 0) targetFormation = allFormations[0];
        }

        if (typeof ProgramView !== 'undefined' && targetFormation) {
            ProgramView.currentFormation = targetFormation;
            ProgramView.currentCategory = targetFormation.type;
            if (subjectId) {
                ProgramView.selectedSubjectId = subjectId;
            }
        }

        if (typeof App !== 'undefined') {
            App.navigate('calendario-formacion');
        }
    },

    // Lo que llega aparte: asistencia (lista pasada), memorias, calificaciones y tareas.
    async initAcademico() {
        const D = DashboardView, token = AuthManager.getCsrfToken(), headers = { 'X-SICAF-CSRF': token };
        const epoch = AuthManager._epoch;
        // Kept, so a repaint of the panel shows them straight away instead of «…».
        const setFig = (id, value, sub, warn) => {
            this._acaFigs[id] = { value, sub, warn: !!warn };
            const cell = document.getElementById(id);
            if (!cell) return;
            cell.querySelector('.aca-fig-value').textContent = value;
            cell.querySelector('.aca-fig-sub').textContent = sub;
            cell.querySelector('.aca-fig-value').classList.toggle('is-warn', !!warn);
        };

        // Cobertura (clases con lista pasada / clases que tocaban), sobre toda la asistencia del
        // servidor: el % de asistencia solo promedia las clases con lista y no diría cuántas faltan.
        if (D._can('asistencia') || D._can('calendario-formacion')) {
            try {
                const now = new Date(), since = D._iso(new Date(now.getFullYear(), now.getMonth() - 2, 1));
                const data = await (await fetch(`/api/attendance/summary?since=${since}`, { headers })).json();
                if (epoch !== AuthManager._epoch || !data.success) throw new Error('sin datos');
                this._acaAttendance = { since, monthly: data.monthly || [], expected: data.expectedOccurrences, recordedCount: data.recordedOccurrences,
                    recorded: new Set((data.records || []).map(r => `${r.classSessionId}|${r.date}`)) };
                setFig('aca-fig-lista', `${Math.round(data.coveragePct)} %`, `${data.recordedOccurrences} de ${data.expectedOccurrences} clases · 3 meses`, data.coveragePct < 80);
                this._acaRepaint('aca-semana');
                this._acaRepaint('aca-lista-meses');
            } catch (e) {
                console.error('Panel Académico: no se pudo cargar la asistencia', e);
            }
        }

        if (document.getElementById('aca-fig-memorias')) {
            try {
                const data = await (await fetch('/api/subject-reports', { headers })).json();
                if (data.success && data.reports) {
                    const total = SubjectService.getSubjects().length, done = Math.min(data.reports.length, total || data.reports.length), missing = Math.max(0, total - done);
                    setFig('aca-fig-memorias', `${done} / ${total}`, missing ? `Faltan ${missing} por entregar` : 'Todas entregadas', missing > 0);
                }
            } catch (e) { console.error('Panel Académico: no se pudieron cargar las memorias', e); }
        }

        // Solo las actas finales: las de trimestre son avances provisionales.
        if (document.getElementById('aca-fig-notas')) {
            try {
                const data = await (await fetch('/api/calificaciones', { headers })).json();
                if (data.success && data.calificaciones) {
                    const finals = data.calificaciones.filter(acta => acta.period === 'Final');
                    const grades = finals.flatMap(acta => (acta.notas || []).filter(n => n.calificacion));
                    const apto = grades.filter(n => n.calificacion === 'APTO').length;
                    setFig('aca-fig-notas', grades.length ? `${Math.round(apto / grades.length * 100)} % apto` : 'Sin notas',
                        finals.length ? `${finals.length} ${finals.length === 1 ? 'acta final cerrada' : 'actas finales cerradas'}` : 'Sin actas finales publicadas');
                }
            } catch (e) { console.error('Panel Académico: no se pudieron cargar las calificaciones', e); }
        }

        // Por tarea abierta: alumnos esperados (los asignados y los de sus formaciones) y cuántos entregaron.
        if (document.getElementById('aca-fig-tareas')) {
            try {
                const data = await (await fetch('/api/tasks', { headers })).json();
                if (data.success) {
                    const now = new Date();
                    const open = (data.tasks || []).filter(t => !t.deadline || new Date(t.deadline) >= now);
                    const students = DataManager.getAll(DataManager.KEYS.STUDENTS);
                    const subs = await Promise.all(open.map(t => fetch(`/api/tasks/${t.id}/submissions`, { headers }).then(r => r.json()).catch(() => ({ success: false }))));
                    let expected = 0, delivered = 0;
                    open.forEach((t, i) => {
                        const ids = new Set([...(t.studentIds || []).map(String),
                            ...students.filter(s => (s.formations || []).some(f => (t.formationIds || []).includes(String(f)))).map(s => String(s.id))]);
                        expected += ids.size;
                        if (subs[i] && subs[i].success) {
                            const done = new Set((subs[i].submissions || []).filter(s => !s.superseded).map(s => String(s.studentId)));
                            delivered += [...ids].filter(id => done.has(id)).length;
                        }
                    });
                    setFig('aca-fig-tareas', expected ? `${delivered} / ${expected}` : '—', open.length ? `Entregas de ${open.length} ${open.length === 1 ? 'tarea abierta' : 'tareas abiertas'}` : 'No hay tareas abiertas', expected && delivered < expected);
                }
            } catch (e) { console.error('Panel Académico: no se pudieron cargar las tareas', e); }
        }
    }
});
